/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface BlueSkyReportSerializer {
  /** Totals for the table */
  totals?: {
    /**
     * Total number of investors
     * @example 10
     */
    total_investors?: number;
    /**
     * Total contributed amount for all investors
     * @example "100.0"
     */
    total_contributed_amount?: string;
  };
  results?: {
    /**
     * Number of active investments grouped by state.
     * @example 3
     */
    investors_count?: number;
    /**
     * Postal code of the state set in the investment account address
     * @example "CA"
     */
    state?: string;
    /**
     * Total contributed amount of the investments in a given state
     * @example "100.0"
     */
    total_contributed_amount?: string;
  }[];
}

export interface TaxReportingSerializer {
  /**
   * Id of the investment
   * @example "54f72418-0fb3-42fe-95b0-b08b0373307f"
   */
  id?: string;
  /**
   * Created at timestamp
   * @format date
   * @example "2019-06-07 18:00"
   */
  created_at?: string;
  /**
   * Formatted created at timestamp
   * @format date
   * @example "2019-06-07 18:00"
   */
  created_at_formatted?: string;
  /**
   * Created at timestamp in milliseconds
   * @example 1573006095
   */
  created_at_millis?: number;
  /**
   * Updated at timestamp
   * @format date
   * @example "2019-06-08 18:00"
   */
  updated_at?: string;
  /**
   * Formatted updated at timestamp
   * @format date
   * @example "2019-06-08 18:00"
   */
  updated_at_formatted?: string;
  /**
   * Updated at timestamp in milliseconds
   * @example 1573006095
   */
  updated_at_millis?: number;
  /**
   * Affiliated Investors
   * @example true
   */
  accr_affiliated_investors?: boolean;
  /**
   * Investment Company Act Matters
   * @example "yes_3c1"
   */
  accr_investment_company_act?: string;
  /**
   * Investment Company Act Matters Humanized
   * @example "Yes, Investor relies on Section 3(c)(1) of the Companies Act"
   */
  accr_investment_company_act_humanized?: string;
  /**
   * FACTA
   * @example true
   */
  accr_investor_rep_non_us_fatca?: boolean;
  /**
   * Accredited Investor
   * @example true
   */
  accredited?: boolean;
  /**
   * City
   * @example "San Mateo"
   */
  address_city?: string;
  /**
   * Country
   * @example "US"
   */
  address_country?: string;
  /**
   * Address
   * @example "123 Main St"
   */
  address_line_one?: string;
  /**
   * Suite, Apt, Unit
   * @example "Unit 1L"
   */
  address_line_two?: string;
  /**
   * Postal
   * @example "94404"
   */
  address_postal?: string;
  /**
   * State
   * @example "VT"
   */
  address_state?: string;
  /**
   * Account #
   * @example "123456789"
   */
  bank_account?: string;
  /**
   * Bank Address
   * @example "7292 Dictum Av."
   */
  bank_address?: string;
  /**
   * Beneficiary Address
   * @example "282 Kevin Brook"
   */
  bank_beneficiary_address?: string;
  /**
   * Bank Name
   * @example "Chase"
   */
  bank_name?: string;
  /**
   * Routing #
   * @example "1010101010"
   */
  bank_routing?: string;
  /**
   * Bank Swift Code
   * @example "CHASUS33"
   */
  bank_swift?: string;
  /**
   * Contact Email
   * @example "eliza@mann.net"
   */
  contact_email?: string;
  /**
   * Contact Name
   * @example "Eliza Santiago"
   */
  contact_name?: string;
  /**
   * Contact Phone
   * @example "(333)333-333"
   */
  contact_phone?: string;
  /**
   * Contact Title
   * @example "Manager"
   */
  contact_title?: string;
  /**
   * Formation Date / DOB
   * @example "2020-10-19T21:11:18.084Z"
   */
  date_of_formation?: string;
  /**
   * Entity Subtype
   * @example "Partnership"
   */
  entity_subtype?: string;
  /**
   * Entity Type
   * @example "limited_liability_company"
   */
  entity_type?: string;
  /**
   * ERISA/DOL Representation
   * @example "option_2"
   */
  erisa_dol?: string;
  /**
   * ERISA/DOL Representation Humanized
   * @example "Investor is Employee Benefit Plan"
   */
  erisa_dol_humanized?: string;
  /**
   * Formation Country
   * @example "US"
   */
  formation_country?: string;
  /**
   * Formation State
   * @example "CA"
   */
  formation_state?: string;
  /**
   * Primary Email
   * @example "rasheeda@kilback.name"
   */
  investor_email?: string;
  /**
   * Primary Investor
   * @example "Rasheed Kilback"
   */
  investor_name?: string;
  /**
   * U.S. Based?
   * @example true
   */
  is_domestic?: boolean;
  /**
   * Formed/Born in U.S.
   * @example true
   */
  is_us_person?: boolean;
  /**
   * Joint Email
   * @example "stacy.rutherford@ritchie.biz"
   */
  joint_email?: string;
  /**
   * Joint Legal Name
   * @example "Ritchie Corp"
   */
  joint_legal_name?: string;
  /**
   * Legal Name
   * @example "Ritchie LLC"
   */
  legal_name?: string;
  /**
   * Qualified Client
   * @example false
   */
  qualified_client?: boolean;
  /**
   * Qualified Purchaser
   * @example false
   */
  qualified_purchaser?: boolean;
  /**
   * Qualified Purchaser - Companies Act
   * @example false
   */
  qualified_purchaser_2?: boolean;
  /**
   * Tax ID
   * @example "******6368"
   */
  tax_id?: string;
  /**
   * Tax ID Type
   * @example "SSN"
   */
  tax_id_type?: string;
  /**
   * Trust Subtype
   * @example "Family"
   */
  trust_subtype?: string;
  /**
   * Trust Type
   * @example "Revocable"
   */
  trust_type?: string;
  /**
   * Beneficiary Address
   * @example "123 Siempre Viva Av."
   */
  wire_beneficiary?: string;
  /**
   * Additional Instructions
   * @example "Additional Instructions"
   */
  wire_instructions?: string;
}

export interface DataRoom {
  /**
   * UUID for this data room
   * @example "36f1b36c-28d1-4321-93b0-0e687373668a"
   */
  id: string;
  /**
   * Name for this data room
   * @example "Sample Fund Series A"
   */
  name: string;
  /**
   * In depth description for this data room
   * @example "A brief description for sample fund series A"
   */
  summary?: string;
  /**
   * Whether or this data room has already been sent
   * @example true
   */
  shared: boolean;
  /**
   * How many prospects have already been invited
   * @example 5
   */
  invites_sent_count?: number;
  /**
   * How many emails have been opened by prospects
   * @example "4"
   */
  emails_opened_count?: number;
  /**
   * How many prospects have loaded the data room
   * @example 3
   */
  views_count?: number;
  /**
   * How many uninvited prospects remain
   * @example 4
   */
  invites_pending_count?: number;
  /**
   * UUID for the organization's data room entity
   * @example "36f1b36c-28d1-4321-93b0-0e687373668a"
   */
  entity_id?: string;
  /**
   * Whether user can download documents from this dataroom
   * @example true
   */
  allow_download: boolean;
  /**
   * Whether this data room requests an NDA
   * @example true
   */
  enabled_nda: boolean;
  /**
   * Whether the NDA is standard or custom (uploaded)
   * @example true
   */
  custom_nda_enabled?: boolean;
  /**
   * The ID of a custom NDA document associated with the data room
   * @example "376f3af0-d3d4-49ab-8e0b-f96de15a9f89"
   */
  nda_document_id?: string;
  /**
   * Whether this data room requests to enable interest indication
   * @example true
   */
  enabled_indicate_interest?: boolean;
  /**
   * Whether owner of this org shold receive a notification whenever a prospect indicates interest, changes interest or denies interest
   * @example true
   */
  enabled_interest_notifications?: boolean;
  /**
   * Organization logo url
   * @example "http://example.com"
   */
  logo_url?: string;
  /** Locale config for the data room */
  locale_config?: {
    /**
     * The ID of the locale config
     * @example "b0efba11-aa3b-450d-95fc-79d2de21ca7d"
     */
    id: string;
    /**
     * The data room id to which the locale config belongs
     * @example "26703848-5d13-4836-a4cb-7f3cc584b4b3"
     */
    data_room_id: string;
    /**
     * The ISO currency code for the locale config
     * @example "EUR"
     */
    currency_code: string;
    /**
     * The unit for the locale config
     * @example "€"
     */
    unit: string;
    /**
     * The delimiter (thousands separator) for the locale config
     * @example "."
     */
    delimiter: string;
    /**
     * The decimal separator for the locale config
     * @example "."
     */
    separator: string;
    /**
     * The rails-friendly format for the locale config
     * @example "%n %u"
     */
    format: string;
    /**
     * The rails-friendly negative format for the locale config
     * @example "-%n %u"
     */
    negative_format: string;
  };
  /**
   * Total prospects are willing to subscribe to in dollars
   * @example 123.45
   */
  interest_indicated_amount?: number;
  /**
   * Organization name
   * @example "Example Organization"
   */
  organization_name: string;
  /**
   * Organization url slug
   * @example "flow-dev-sandbox"
   */
  organization_slug: string;
  /**
   * Primary color
   * @example "#736EAA"
   */
  primary_color?: string;
  /**
   * Email of the user who created this data room
   * @example "example_owner@example.com"
   */
  creator_email?: string;
  /**
   * How many prospects show interest on this data room
   * @example 3
   */
  interested?: number;
  /**
   * How many prospects rejected this data room
   * @example 2
   */
  declined?: number;
}

export interface DataRoomPeek {
  /**
   * ID of the data room
   * @example "2215ead5-0665-4f2e-802b-453aaa623e03"
   */
  id: string;
  /**
   * Logo url for this data room's organization
   * @example "http://example.com"
   */
  logo_url?: string;
  /**
   * Name for this data room
   * @example "Sample Fund Series A"
   */
  data_room_name?: string;
  /**
   * Name for this data room's name
   * @example "Sample Organization"
   */
  organization_name: string;
  /**
   * Url slug for this data room's organization
   * @example "flow-dev-sandbox"
   */
  organization_slug: string;
  /**
   * The primary color for the organization
   * @example "#826AF6"
   */
  primary_color: string;
  /** Whether a data room can be shared through public registration form */
  shareable: boolean;
  /** Whether a data room allows document */
  allow_download: boolean;
}

export interface DataRoomDocument {
  /**
   * UUID for this document
   * @example "36f1b36c-28d1-4321-93b0-0e687373668a"
   */
  id: string;
  /**
   * ID for the folder containing this document, if any
   * @example "36f1b36c-28d1-4321-93b0-0e687373668a"
   */
  folder_id?: string;
  /**
   * Title for this document
   * @example "Sample.pdf"
   */
  title: string;
  /**
   * Preview images for this document
   * @example ["https://flow-ke-local.s3.amazonaws.com/sample.jpg"]
   */
  previews?: string[];
}

export interface DataRoomDocumentFolder {
  /**
   * UUID for this document folder
   * @example "36f1b36c-28d1-4321-93b0-0e687373668a"
   */
  id?: string;
  /**
   * Name for this document folder
   * @example "Accounting"
   */
  label?: string;
  /** Documents within this data room document folder */
  documents?: DataRoomDocument[];
  /**
   * A timestamp when this document was last updated
   * @example "2023-04-10 15:58:09 UTC"
   */
  updated_at?: string;
}

export interface DocumentFolderFragment {
  /**
   * UUID for this document folder
   * @example "36f1b36c-28d1-4321-93b0-0e687373668a"
   */
  id: string;
  /**
   * Name for this document folder
   * @example "Accounting"
   */
  label: string;
}

export interface DataRoomDocumentsAndFolders {
  /** Currently selected folder */
  current_folder?: DataRoomDocumentFolder;
  /**
   * UUID for this document folder
   * @example "36f1b36c-28d1-4321-93b0-0e687373668a"
   */
  id?: string;
  /** Documents owned by this data room at the root */
  documents: DataRoomDocument[];
  /** Folders available on this data room */
  folders: DataRoomDocumentFolder[];
  /** Fragments are used to show navigational hierarchy in the UI */
  ancestor_fragments?: DocumentFolderFragment[];
}

export interface DataRoomDocumentDownloadUrl {
  /**
   * Download token
   * @example "123abc"
   */
  download_token?: string;
  /**
   * Data of expiration
   * @example "12/12/2022"
   */
  expires_at?: string;
}

export interface Page {
  /**
   * Page image ID
   * @example "33c67cd9-4d51-44a5-8391-68ca7dc229a9"
   */
  id: string;
  /**
   * Page image URL
   * @example "https://test.com/abc.jpg"
   */
  image: string;
}

export interface DataRoomNda {
  /**
   * HTML version for NDA
   * @example "<h1>NDA</h1><p>This NDA..."
   */
  standard_nda?: string;
  /** Preview images for this document */
  custom_nda?: Page[];
  /**
   * ID of a custom nda document associated with the data room
   * @example "376f3af0-d3d4-49ab-8e0b-f96de15a9f89"
   */
  nda_document_id?: string;
}

/** Failed to access this endpoint */
export interface ErrorPayload {
  /**
   * Reason for this error
   * @example "Invalid parameters"
   */
  error?: string;
}

export interface DataRoomProspect {
  /**
   * UUID for this prospect
   * @example "36f1b36c-28d1-4321-93b0-0e687373668a"
   */
  id?: string;
  /**
   * First name for this prospect
   * @example "John"
   */
  first_name?: string;
  /**
   * Last name for this prospect
   * @example "Doe"
   */
  last_name?: string;
  /**
   * Email for this prospect
   * @example "johndoe@example.com"
   */
  email?: string;
  /**
   * Current state for this prospect [invite_pending, initial, email_sent,email_opened, viewed_data_room, interest_indicated, declined]
   * @example "invite_pending"
   */
  state?: string;
  /**
   * Initials for the prospect
   * @example "pl"
   */
  initials?: string;
  /**
   * The potential commitment amount in dollars this LP shows if interest is "yes"
   * @example 100000
   */
  interested_amount?: number;
  /**
   * A timestamp when this prospect accepted the NDA, blank if not accepted (yet)
   * @example "null"
   */
  signed_nda_at?: string;
  /**
   * The ID for the Data Room this prospect belongs to
   * @example "36f1b36c-28d1-4321-93b0-0e687373668a"
   */
  data_room_id?: string;
  /**
   * The interest this LP shows for this data room
   * @example "yes"
   */
  interested?: string;
  /**
   * The minimum commitment amount in dollars this LP shows if interest is "maybe"
   * @example 10000
   */
  interested_amount_range_start?: number;
  /**
   * The maximum commitment amount in dollars this LP shows if interest is "maybe"
   * @example 150000
   */
  interested_amount_range_end?: number;
  /**
   * User ID associated to this prospect
   * @example "01010000-0000-0000-0000-000000000000"
   */
  user_id?: string;
}

export type DataRoomProspectCreate = DataRoomProspect[];

export interface User {
  /**
   * User ID
   * @example "ec64f036-8a4b-4821-a001-ed9a092056ae"
   */
  id: string;
  /**
   * Whether the user is a flow admin
   * @example true
   */
  admin?: boolean;
  /**
   * Email of the user
   * @example "priyam@gmail.com"
   */
  email: string;
  /**
   * First name of the user
   * @example "Priyam"
   */
  first_name?: string;
  /**
   * Last name of the user
   * @example "Gupta"
   */
  last_name?: string;
  /**
   * Middle name of the user
   * @example "Kumar"
   */
  middle_name?: string;
  /**
   * Full name of the user with middle intial
   * @example "Priyam K Gupta"
   */
  name: string;
  /**
   * Full name of the user with middle name
   * @example "Priyam Kumar Gupta"
   */
  full_name: string;
  /**
   * Initials of the user
   * @example "PG"
   */
  initials: string;
  /**
   * Is the user being impersonated
   * @example "true"
   */
  impersonated: boolean;
  /**
   * Is the impersonation session locked to its organization (GP impersonators; Flow admins are exempt)
   * @example "true"
   */
  impersonation_scoped?: boolean;
  /**
   * URL slug of the organization the impersonation session is scoped to
   * @example "acme-capital"
   */
  impersonation_organization_slug?: string | null;
}

export interface Filter {
  /**
   * Filter label
   * @example "Fund"
   */
  label: string;
  /**
   * key to link the dropdown to the options list
   * @example "filter_vehicles"
   */
  key: string;
  /**
   * Query Key for the filter
   * @example "filter_investor_id[]"
   */
  query_key: string;
  /**
   * Filter selector type
   * @example "multi"
   */
  selector_type: string;
}

/** An option for a dropdown filter */
export interface FilterOption {
  /**
   * ID of the filter option
   * @example "2215ead5-0665-4f2e-802b-453aaa623e03"
   */
  id: string;
  /**
   * Filter option label
   * @example "Manchaware, LLC "
   */
  label: string;
  /**
   * Filter option value
   * @example "45678"
   */
  value: string;
}

/** Collection of options for a dropdown menu */
export type FilterOptions = FilterOption[];

export interface ResourceAvailableFilters {
  /** Array of Filters */
  available_filters: Filter[];
  /** Map of all the filter options, keyed by each filter in the group */
  filter_options: Record<string, FilterOptions>;
}

/** Array of organizations */
export type Organizations = Organization[];

export interface Organization {
  /**
   * Organization ID
   * @example "ec64f036-8a4b-4821-a001-ed9a092056ae"
   */
  id: string;
  /**
   * A boolean indicating wether the capital calls feature is enabled
   * @example true
   */
  enable_investor_portal_capital_calls?: boolean;
  /**
   * The entity id of the organization
   * @example "ec64f036-8a4b-4821-a001-ed9a092056ae"
   */
  entity_id?: string;
  /**
   * URL slug of the organization
   * @example "test-slug"
   */
  url_slug: string;
  /**
   * Organization Name
   * @example "Loud Capital"
   */
  name: string;
  /**
   * Organization Entity Logo Url
   * @example "https://flow-ke-local.s3.amazonaws.com/logos/kph3m6uKRw2fyqmeVfqV_gus.jpg"
   */
  logo?: string;
  /**
   * White label color
   * @example "#123456"
   */
  primary_color: string;
  /**
   * A boolean indicating whether the organization is suspended
   * @example true
   */
  suspended: boolean;
}

export interface InvestmentsOverview {
  /**
   * Investments Overview ID
   * @example "b3df4b76-63dc-4490-a02c-5d1ed1cb3843"
   */
  id: string;
  /** Array of investment summaries */
  results: InvestmentsOverviewResults;
  /** Hash of investment summaries, keyed by their common vehicle currency code */
  results_by_currency_code?: Record<string, InvestmentsOverviewResults>;
  totals: InvestmentsOverviewTotals;
  /** Hash of totals across investments, keyed by their common vehicle currency code */
  totals_by_currency_code?: Record<string, InvestmentsOverviewTotals>;
}

/** Array of investment summaries */
export type InvestmentsOverviewResults = InvestmentSummary[];

export interface InvestmentSummary {
  /**
   * Investment ID
   * @example "5f073891-5595-4290-bf42-47131d557dd5"
   */
  id: string;
  /**
   * Vehicle Name
   * @example "Loud Capital"
   */
  vehicle_name: string;
  /**
   * Investor Name
   * @example "Priyam Gupta"
   */
  investor_name: string;
  /**
   * Committed Amount
   * @example "$100,000.00"
   */
  committed_amount_formatted: string;
  /**
   * Committed Amount in cents
   * @example "10000000"
   */
  committed_amount_cents: number;
  /**
   * Contributed Amount
   * @example "$100,000.00"
   */
  contributed_amount_formatted: string;
  /**
   * Contributed Amount in cents
   * @example "10000000"
   */
  contributed_amount_cents: number;
  /**
   * Unfunded Amount
   * @example "$100,000.00"
   */
  unfunded_amount_formatted: string;
  /**
   * Unfunded Amount in cents
   * @example "10000000"
   */
  unfunded_amount_cents: number;
  /**
   * Net Asset Value
   * @example "$100,000.00"
   */
  net_asset_value_formatted: string;
  /**
   * Net Asset Value in cents
   * @example "10000000"
   */
  net_asset_value_cents: number;
  /**
   * Life Distributions
   * @example "$100,000.00"
   */
  life_distributions_formatted: string;
  /**
   * Life Distributions in cents
   * @example "10000000"
   */
  life_distributions_cents: number;
  /**
   * As of Date
   * @example "2023-10-31T00:00:00.000Z"
   */
  as_of: string;
}

export interface InvestmentsOverviewTotals {
  /**
   * Total Committed
   * @example "$100,000.00"
   */
  total_committed_amount: string;
  /**
   * Total Contributed
   * @example "$100,000.00"
   */
  total_contributed_amount: string;
  /**
   * Total Unfunded
   * @example "$100,000.00"
   */
  total_unfunded_amount: string;
  /**
   * Total NAV
   * @example "$100,000.00"
   */
  total_net_asset_value_amount: string;
  /**
   * Total Distributions
   * @example "$100,000.00"
   */
  total_life_distributions_amount: string;
}

export interface Document {
  /**
   * Document ID
   * @example "9347b4ae-578e-4347-a957-f30c9ed4c0dc"
   */
  id: string;
  /**
   * Title of the document
   * @example "My Document"
   */
  title: string;
  /**
   * Page count of the document
   * @example "26 pages"
   */
  page_count_formatted?: string;
  /**
   * Date of the last update of the document
   * @example "2020-10-09T17:36:08.529Z"
   */
  updated_at: date;
  /**
   * Tags of the document
   * @example ["Tag1","Tag2"]
   */
  tags?: string[];
  /**
   * Name of the organization
   * @example "Loud Capital"
   */
  organization_name: string;
  /**
   * Logo of the organization
   * @example "https://test.com/logos/kpus.jpg"
   */
  organization_logo?: string;
  /**
   * Primary color of the organization
   * @example "#fff"
   */
  organization_primary_color: string;
  /**
   * Name of the Fund
   * @example "Fund A"
   */
  vehicle_name?: string;
  /** Pages of the document */
  pages: Page[];
  /**
   * Is the document view only or view & download
   * @example true
   */
  allow_download: boolean;
  /**
   * Preview of the document
   * @example "<p>Test</p>"
   */
  preview?: string;
}

export interface ThinDocument {
  /**
   * Document ID
   * @example "9347b4ae-578e-4347-a957-f30c9ed4c0dc"
   */
  id: string;
  /**
   * Title of the document
   * @example "My Document"
   */
  title: string;
  /**
   * Folder name of the document
   * @example "My Folder"
   */
  folder_name?: string;
  /**
   * Name of the Fund
   * @example "Fund A"
   */
  vehicle_name: string;
  /**
   * Name of the Investor
   * @example "John Doe"
   */
  investor_name?: string;
  /**
   * Date of the last update of the document
   * @example "2020-10-09T17:36:08.529Z"
   */
  updated_at: string;
  /**
   * Does this user have download permissions?
   * @example "true"
   */
  allow_download: boolean;
}

export interface DocumentDownloadUrl {
  /**
   * Download token
   * @example "https://test.com/documents/abc.pdf"
   */
  download_token: string;
  /**
   * Data of expiration
   * @example "12/12/2022"
   */
  expires_at: string;
}

/** Array of Cached Tasks */
export type Tasks = Task[];

export interface Task {
  /**
   * Task ID
   * @example "ec64f036-8a4b-4821-a001-ed9a092056ae"
   */
  id: string;
  /**
   * URL slug for Task
   * @example "test-slug"
   */
  cta_url: string;
  /**
   * Label for the task
   * @example "Sign Subscription agreement"
   */
  cta_label: string;
  /**
   * Logo for the task
   * @example "https://flow-ke-local.s3.amazonaws.com/logos/kph3m6uKRw2fyqmeVfqV_gus.jpg"
   */
  logo?: string;
  /**
   * Investment Legal Name
   * @example "Investment LLC"
   */
  vehicle_legal_name?: string;
  /**
   * Investment Account Name for the task
   * @example "James Beard"
   */
  investment_account_name: string;
  /**
   * Description of the task
   * @example "Please connect your account to the Investor Portal"
   */
  task_description: string;
}

export interface ThinInvestmentAccount {
  /**
   * Investment Account ID
   * @example "9347b4ae-578e-4347-a957-f30c9ed4c0dc"
   */
  id: string;
  /**
   * Display or Legal Name
   * @example "Investor Holdings, LLC"
   */
  name: string;
  /**
   * Entity Type as enum
   * @example "limited_liability_company"
   */
  entity_type?: string;
  /**
   * Formatted Entity Type
   * @example "Limited Liability Company"
   */
  entity_type_formatted: string;
}

export interface WorkflowTaskActor {
  /**
   * Investment Workflow Task Actor ID
   * @example "308bb481-0b6c-4187-aed9-7a64b828f9f8"
   */
  id: string;
  /**
   * User ID
   * @example "a4072f02-34e1-46e1-bfe4-777fa4806fa4"
   */
  user_id: string;
  /**
   * Full name of the user
   * @example "John Doe"
   */
  full_name: string;
  /**
   * Email of the user
   * @example "jXW9Q@example.com"
   */
  email: string;
  /**
   * Role of the actor
   * @example "primary_1"
   */
  role: string;
}

export interface WorkflowTask {
  /**
   * Workflow Task ID
   * @example "1c0edc80-5d44-4826-b457-6589dfd3864a"
   */
  id: string;
  /**
   * Workflow Task title
   * @example "How will you invest?"
   */
  title: string;
  /**
   * Workflow Task description
   * @example "Fill out form to describe how you will invest"
   */
  description: string;
  /**
   * Workflow Task progress
   * @example "completed"
   */
  progress: "completed" | "started" | "unstarted";
  /**
   * Workflow Task cta_label
   * @example "Select Investment Profile"
   */
  cta_label: string;
  /**
   * Is the form related to the task reassignable to another team member?
   * @example "true"
   */
  reassignable: boolean;
  /**
   * Workflow Task cta_url
   * @example "http://localhost:4201/e/undefined/workflow/739c9a51-6878-4f79-b616-9be0475f5093/task/33c8b9d4-ecb5-4d03-9bc5-c085d5a680e4"
   */
  cta_url: string;
  /**
   * Is this the first task?
   * @example "true"
   */
  first: boolean;
  /**
   * Is this the last task?
   * @example "false"
   */
  last: boolean;
  /** Current actor of the task? */
  current_actor?: WorkflowTaskActor;
  /**
   * Has the task been locked?
   * @example "true"
   */
  locked: boolean;
  /**
   * Order of the task in the collection
   * @example 3
   */
  position: number;
  /**
   * Has the task been completed by the logged in user?
   * @example "true"
   */
  completed_by_logged_in_actor: boolean;
  /**
   * Full name of the impersonating user who actually completed the task, when applicable
   * @example "Grace Prentice"
   */
  completed_by_impersonator_name?: string | null;
  /** Currently logged in actor */
  logged_in_actor: WorkflowTaskActor;
}

export interface Workflow {
  /**
   * Workflow ID
   * @example "1c0edc80-5d44-4826-b457-6589dfd3864a"
   */
  id: string;
  /** Workflow tasks */
  tasks: WorkflowTask[];
  /** Current Task */
  current_task?: WorkflowTask;
}

export interface Vehicle {
  /**
   * Vehicle ID
   * @example "274befcd-f6a6-4642-90d0-323869e1bb54"
   */
  id: string;
  /**
   * Vehicle name
   * @example "Adrian's Master Fund - Series 1"
   */
  name: string;
}

export interface Investment {
  /**
   * Investment ID
   * @example "308bb481-0b6c-4187-aed9-7a64b828f9f8"
   */
  id: string;
  /**
   * Summary of the investments' vehicle
   * @example "XYZ Fund supports green energy"
   */
  summary?: string;
  /**
   * Access Type for entity member
   * @example "owner"
   */
  entity_member_role?: string;
  /**
   * Name of the investments' investment account
   * @example "XYZ Inc"
   */
  investment_account_name: string;
  /**
   * ID of the investments' investment account
   * @example "1024da47-9d67-431b-b0ee-062f20eedb7b"
   */
  investment_account_id: string;
  /** Workflow of the investment */
  workflow: Workflow;
  /** Vehicle of the investment */
  vehicle: Vehicle;
  /**
   * Subscribed amount for the investment towards a fund
   * @example "$500.00"
   */
  committed_amount_formatted: string;
  /**
   * Contributed amount for the investment towards a fund
   * @example "$400.00"
   */
  contributed_amount_formatted: string;
  /**
   * Unfunded (committed - contributed) amount for the investment towards a fund
   * @example "$100.00"
   */
  unfunded_amount_formatted: string;
  /**
   * Net Asset Value of the investment
   * @example "$0.00"
   */
  nav_formatted: string;
  /**
   * Life Distributions of the investment
   * @example "$0.00"
   */
  distributions_formatted: string;
  /**
   * Date of most recent investment update
   * @example "2023-10-31T00:00:00.000Z"
   */
  as_of: string;
}

export interface EntityMemberRole {
  /**
   * Entity Member Role ID
   * @example "462befda-d06c-442c-a807-1852e20b7a2e"
   */
  id: string;
  /**
   * ID of the Entity Member
   * @example "0bd3fdee-a264-446f-9aa0-5fb7f0d0113c"
   */
  entity_member_id: string;
  /**
   * Entity Member Role created at
   * @example "2023-08-25T18:11:05.012Z"
   */
  created_at: string;
  /**
   * Entity Member Role archived at
   * @example "2024-08-25T18:11:05.012Z"
   */
  archived_at?: string;
  /**
   * Role of the Entity Member
   * @example "primary_contact"
   */
  role: string;
}

/** Array of members */
export type Members = Member[];

export interface Member {
  /**
   * Investment Member ID
   * @example "ec64f036-8a4b-4821-a001-ed9a092056ae"
   */
  id: string;
  /**
   * Entity ID of the member
   * @example "ec64f036-8a4b-4821-a001-ed9a092056ae"
   */
  entity_id: string;
  /**
   * User ID
   * @example "ec64f036-8a4b-4821-a001-ed9a092056ae"
   */
  user_id: string;
  /**
   * Member created at
   * @example "2020-01-01"
   */
  created_at?: string;
  /**
   * Title of the member
   * @example "Investor"
   */
  title?: string;
  /**
   * Role of the member
   * @example "Individual"
   */
  role: string;
  /**
   * Email of the member
   * @example "user@test.com"
   */
  email: string;
  /**
   * Member first name
   * @example "Ryan"
   */
  first_name: string;
  /**
   * Member last name
   * @example "Rogers"
   */
  last_name: string;
  /**
   * Member middle name
   * @example "M."
   */
  middle_name?: string;
  /**
   * Member name
   * @example "Ryan M. Rogers"
   */
  name: string;
  /**
   * Member status
   * @example "Active"
   */
  status?: string;
  /**
   * Invitation token
   * @example "zbk9jVApDL2noj29DerfXw3E"
   */
  invitation_token?: string;
  /** Entity Member roles */
  entity_member_roles: EntityMemberRole[];
  /** Communication Types */
  communication_types: string[];
}

export interface ReassignParams {
  /**
   * New assignee ID
   * @example "1C0EDC80-5D44-4826-B457-6589DFD3864A"
   */
  user_id?: string;
  /**
   * New assignee name
   * @example "John Doe"
   */
  name?: string;
  /**
   * New assignee email
   * @example "j.doe@flowinc.com"
   */
  email?: string;
  /**
   * Subject for email
   * @example "Subject"
   */
  subject?: string;
  /**
   * Message for email
   * @example "Message"
   */
  message?: string;
}

export interface Address {
  /**
   * Address id
   * @example "ffffdeb8-3bff-4da8-97d1-c2b7e1fcc31e"
   */
  id: string;
  /**
   * City
   * @example "Spokane"
   */
  city?: string;
  /**
   * Address Country
   * @example "US"
   */
  country?: string;
  /**
   * Full Address
   * @example "2754  Goodwin Avenue\nSpokane, WA, 99201"
   */
  full_address?: string;
  /**
   * Address line one
   * @example "2754  Goodwin Avenue"
   */
  line_one?: string;
  /**
   * Address line two
   * @example null
   */
  line_two?: string;
  /**
   * Address Locality
   * @example "Spokane, WA, 99201"
   */
  locality?: string;
  /**
   * Contact postal
   * @example "99201"
   */
  postal?: string;
  /**
   * Uppercased state code of the address
   * @example "CA"
   */
  state_code_upcase?: string;
  /**
   * State code of the address
   * @example "ca"
   */
  state_code?: string;
  /**
   * State uppercased
   * @example "CA"
   */
  state_upcase?: string;
  /**
   * State of the address
   * @example "ca"
   */
  state?: string;
  /**
   * Contact Address Street Address
   * @example "2754  Goodwin Avenue"
   */
  street_address?: string;
}

export interface BankAccount {
  /**
   * ID of the bank account
   * @example "d4578890-234d3-4da6-a264-42e6eeafd2a9"
   */
  id: string;
  /**
   * Name of the bank account holder
   * @example "John Doe LLC"
   */
  account_name?: string;
  /** Account number of the bank account */
  account_number?: string;
  /** Obfuscated Account number of the bank account */
  account_number_last_four?: string;
  /**
   * Name of the bank
   * @example "First Citizens"
   */
  bank_name?: string;
  /**
   * Email of the bank contact
   * @example "jdoe@flowinc.com"
   */
  contact_email?: string;
  /**
   * Name of the bank contact
   * @example "Jane Doe"
   */
  contact_name?: string;
  /**
   * Phone number of the bank contact
   * @example "415-867-5309"
   */
  contact_phone?: string;
  /**
   * Full address of the beneficiary
   * @example "12 John St Elizabeth NJ"
   */
  beneficiary_address?: string;
  /** Additional instructions for the bank account */
  notes?: string;
  /**
   * Routing number of the bank account
   * @example "0123454321"
   */
  routing_number?: string;
  /** Swift code of the bank account */
  swift_code?: string;
  /** Wire instructions for the bank account */
  wire_instructions?: string;
  address?: Address;
}

export interface InvestmentAccount {
  address?: Address;
  bank_account?: BankAccount;
  /**
   * Contact email
   * @example "jdoe@flowinc.com"
   */
  contact_email?: string;
  /**
   * Contact name
   * @example "John Doe"
   */
  contact_name?: string;
  /**
   * Contact phone number
   * @example "415-867-5309"
   */
  contact_phone?: string;
  /**
   * Contact title
   * @example "LP Chief"
   */
  contact_title?: string;
  /**
   * Date of formation
   * @example "2023-09-01"
   */
  date_of_formation?: string;
  /**
   * Display name of investment account. May be different than Legal name
   * @example "Adrian's Investment Firm"
   */
  display_name?: string;
  /**
   * Legal name of the disregarded entity
   * @example "Company ABC"
   */
  disregarded_entity_legal_name?: string;
  /**
   * Tax ID for the disregarded entity
   * @example "12345679"
   */
  disregarded_entity_tax_id?: string;
  /**
   * Type of entity
   * @example "limited_liability_company"
   */
  entity_type?: string;
  /**
   * Access Type for entity member
   * @example "owner"
   */
  entity_member_role?: string;
  /**
   * Formation country
   * @example "United States"
   */
  formation_country?: string;
  /**
   * Formation state
   * @example "ca"
   */
  formation_state?: string;
  /**
   * Full address
   * @example "158 11th St\nSan Francisco, CA, 94131"
   */
  full_address?: string;
  /**
   * Entity ID
   * @example "308bb481-0b6c-4187-aed9-7a64b828f9f8"
   */
  id: string;
  /**
   * Legal Name of the entity
   * @example "Adrian's Investment Firm, LLC"
   */
  legal_name?: string;
  /**
   * Name of the investment account (Display name if present)
   * @example "Adrian's Investment Firm"
   */
  name?: string;
  /**
   * Notes
   * @example "This fund is the best fund"
   */
  notes?: string;
  /**
   * Subtype
   * @example "partnership"
   */
  subtype?: string;
  /**
   * Obscured tax ID
   * @example "**********ad13"
   */
  tax_id_last_four?: string;
  /**
   * Tax ID Type
   * @example "Tax ID"
   */
  tax_id_type?: string;
  /**
   * Trust subtype
   * @example "Family"
   */
  trust_subtype?: string;
  /**
   * Trust type
   * @example "Revocable"
   */
  trust_type?: string;
}

export interface CapitalCallsSummaryResults {
  /**
   * ID for record (not used)
   * @example "5F073891-5595-4290-BF42-47131D557DD5"
   */
  id: string;
  /** Array of capital call investments */
  results: CapitalCallInvestment[];
  /** Hash of capital call investments, keyed by their common vehicle currency code */
  results_by_currency_code: Record<string, CapitalCallInvestmentResults>;
  totals: CapitalCallInvestmentsTotals;
  /** Hash of totals across capital calls, keyed by their common vehicle currency code */
  totals_by_currency_code: Record<string, CapitalCallInvestmentsTotals>;
}

/** Array of capital call investments */
export type CapitalCallInvestmentResults = CapitalCallInvestment[];

export interface CapitalCallInvestmentsTotals {
  /**
   * Total Committed Amount
   * @example "$100,000.00"
   */
  total_capital_amount: string;
  /**
   * Total Fees Amount
   * @example "$100,000.00"
   */
  total_fees_amount: string;
  /**
   * Total Expense Amount
   * @example "$100,000.00"
   */
  total_expense_amount: string;
  /**
   * Total Due Amount
   * @example "$100,000.00"
   */
  total_due_amount: string;
}

export interface CapitalCallInvestment {
  /**
   * Capital Call Investment ID
   * @example "5F073891-5595-4290-BF42-47131D557DD5"
   */
  id: string;
  /**
   * Committed Amount
   * @example "$100,000.00"
   */
  capital_amount: string;
  /**
   * Committed Amount in cents
   * @example "10000000"
   */
  capital_amount_cents: number;
  /**
   * Fees Amount
   * @example "$100,000.00"
   */
  fees_amount: string;
  /**
   * Committed Amount in cents
   * @example "10000000"
   */
  fees_amount_cents: number;
  /**
   * Expense Amount
   * @example "$100,000.00"
   */
  expense_amount: string;
  /**
   * Committed Amount in cents
   * @example "10000000"
   */
  expense_amount_cents: number;
  /**
   * Total Due Amount
   * @example "$100,000.00"
   */
  total_due_amount: string;
  /**
   * Committed Amount in cents
   * @example "10000000"
   */
  total_due_amount_cents: number;
  /**
   * Investor Name
   * @example "John Doe"
   */
  investor_name: string;
  /**
   * Vehicle Name
   * @example "Coffee"
   */
  vehicle_name: string;
  /**
   * Due Date
   * @example "Oct 3, 2022"
   */
  due_date: string;
  /**
   * Capital Call Label
   * @example "Capital Call 1"
   */
  call_name: string;
  /**
   * Document ID
   * @example "5F073891-5595-4290-BF42-47131D557DD5"
   */
  document_id: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "http://localhost:3000";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title No title
 * @baseUrl http://localhost:3000
 */
export class FlowAPI<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  v1 = {
    /**
     * @description Blue Sky Report
     *
     * @tags Vehicle Reports
     * @name VehiclesReportsBlueSkyDetail
     * @summary Blue Sky Report
     * @request GET:/v1/vehicles/{vehicle_id}/reports/blue_sky
     * @secure
     */
    vehiclesReportsBlueSkyDetail: (
      vehicleId: string,
      params: RequestParams = {},
    ) =>
      this.request<BlueSkyReportSerializer[], void>({
        path: `/v1/vehicles/${vehicleId}/reports/blue_sky`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Profile Data Report
     *
     * @tags Vehicle Reports
     * @name VehiclesReportsProfileDataDetail
     * @summary Profile Data Report
     * @request GET:/v1/vehicles/{vehicle_id}/reports/profile_data
     * @secure
     */
    vehiclesReportsProfileDataDetail: (
      vehicleId: string,
      params: RequestParams = {},
    ) =>
      this.request<TaxReportingSerializer[], void>({
        path: `/v1/vehicles/${vehicleId}/reports/profile_data`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description List of form sections for an specified vehicle
     *
     * @tags Vehicle, Form, Section
     * @name VehiclesReportsLegalDataFormsSectionsDetail
     * @summary List of form sections for an specified vehicle
     * @request GET:/v1/vehicles/{vehicle_id}/reports/legal_data/forms_sections
     * @secure
     */
    vehiclesReportsLegalDataFormsSectionsDetail: (
      vehicleId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          id?: string;
          name?: string;
        }[],
        any
      >({
        path: `/v1/vehicles/${vehicleId}/reports/legal_data/forms_sections`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description This endpoint returns the investment's custom values
     *
     * @tags Vehicle, investments, custom_values
     * @name VehiclesReportsLegalDataDetail
     * @summary List of column and rows for the questionnaire review
     * @request GET:/v1/vehicles/{vehicle_id}/reports/legal_data
     * @secure
     */
    vehiclesReportsLegalDataDetail: (
      vehicleId: string,
      states?: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          columns?: {
            /** @example "Lorem ipsum dolor sit amet, consectetur adipiscing elit" */
            value?: string;
            /** @example "string" */
            type?: string;
            /** @example "cv_key_1" */
            cv_key?: string;
          }[];
          rows?: {
            /** @example "Lorem ipsum" */
            cv_key_1?: string;
            /** @example "incomplete" */
            signature_request_state?: string;
            /** @example null */
            state_updated_at?: string;
            /** @example "xxxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" */
            investment_id?: string;
            /** @example "email@flowinc.com" */
            investor_email?: string;
            /** @example "Investor Name" */
            investor?: string;
          }[];
        }[],
        any
      >({
        path: `/v1/vehicles/${vehicleId}/reports/legal_data`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  investors = {
    /**
     * @description Fetch the currently authenticated prospect's data room
     *
     * @tags Investor
     * @name DataRoomList
     * @summary Fetch the currently authenticated prospect's data room
     * @request GET:/investors/data_room
     */
    dataRoomList: (params: RequestParams = {}) =>
      this.request<DataRoom, any>({
        path: `/investors/data_room`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Update the current investors state as having viewed the data room
     *
     * @tags Investor
     * @name DataRoomContinueCreate
     * @summary Update the current investors state as having viewed the data room
     * @request POST:/investors/data_room/continue
     */
    dataRoomContinueCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/investors/data_room/continue`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Fetch the documents for the currently authenticated prospect's data room
     *
     * @tags Investor
     * @name DataRoomDocumentsList
     * @summary Fetch the documents for the currently authenticated prospect's data room
     * @request GET:/investors/data_room/documents
     */
    dataRoomDocumentsList: (
      query?: {
        /** Optional Folder ID */
        folder_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DataRoomDocumentsAndFolders, any>({
        path: `/investors/data_room/documents`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Fetch the previews of a data room document
     *
     * @tags Investor
     * @name DataRoomDocumentsDetail
     * @summary Fetch the previews of a data room document
     * @request GET:/investors/data_room/documents/{id}
     */
    dataRoomDocumentsDetail: (id: string, params: RequestParams = {}) =>
      this.request<DataRoomDocument, any>({
        path: `/investors/data_room/documents/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description One of prospect_id or data_room_id is required
     *
     * @tags Investor
     * @name DataRoomPeekList
     * @summary Fetch the publicly available data room details
     * @request GET:/investors/data_room/peek
     */
    dataRoomPeekList: (
      query?: {
        /** Prospect UUID for this invite */
        prospect_id?: string;
        /** Data Room UUID */
        data_room_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DataRoomPeek, any>({
        path: `/investors/data_room/peek`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Fetch the text for NDA acceptance / rejection
     *
     * @tags Investor
     * @name DataRoomNdaList
     * @summary Fetch the text for NDA acceptance / rejection
     * @request GET:/investors/data_room/nda
     */
    dataRoomNdaList: (params: RequestParams = {}) =>
      this.request<DataRoomNda, any>({
        path: `/investors/data_room/nda`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Sends a magic link to the given prospect if the data room contains a prospect with a matching email
     *
     * @tags Investor
     * @name DataRoomRequestMagicLink
     * @summary Request a magic link sent to the given email address
     * @request POST:/investors/data_room/{data_room_id}/request_magic_link
     */
    dataRoomRequestMagicLink: (
      dataRoomId: string,
      bodyParams: {
        /**
         * Email
         * @example "test@flowinc.com"
         */
        email: string;
        /**
         * The front end path to a resource to redirect to
         * @example "/document/29cb7dd8-24a7-4657-8e00-f5035440b756"
         */
        redirect_path?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "If that email is registered to this data room, a magic link has been sent." */
          message?: string;
        },
        any
      >({
        path: `/investors/data_room/${dataRoomId}/request_magic_link`,
        method: "POST",
        body: bodyParams,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Fetch the download token and expiration date
     *
     * @tags Investor
     * @name DataRoomDocumentsDownloadUrlDetail
     * @summary Fetch the download token and expiration date
     * @request GET:/investors/data_room/documents/{id}/download_url
     */
    dataRoomDocumentsDownloadUrlDetail: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<DataRoomDocumentDownloadUrl, any>({
        path: `/investors/data_room/documents/${id}/download_url`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Fetch the currently authenticated prospect
     *
     * @tags Investor
     * @name DataRoomProspectList
     * @summary Fetch the currently authenticated prospect
     * @request GET:/investors/data_room/prospect
     */
    dataRoomProspectList: (params: RequestParams = {}) =>
      this.request<DataRoomProspect, any>({
        path: `/investors/data_room/prospect`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Data Room needs to be shareable
     *
     * @tags Investor
     * @name DataRoomProspectCreate
     * @summary Create prospects on a shareable data room
     * @request POST:/investors/data_room/prospect
     */
    dataRoomProspectCreate: (
      params: {
        data_room_id: string;
        first_name?: string;
        last_name?: string;
        company_name?: string;
        email: string;
        redirect_path?: string;
      },
      requestParams: RequestParams = {},
    ) =>
      this.request<DataRoomProspectCreate, any>({
        path: `/investors/data_room/prospect`,
        method: "POST",
        body: params,
        type: ContentType.Json,
        ...requestParams,
      }),

    /**
     * @description Allow a prospect to accept the NDA
     *
     * @tags Investor
     * @name DataRoomProspectAcceptNdaCreate
     * @summary Allow a prospect to accept the NDA
     * @request POST:/investors/data_room/prospect/accept_nda
     */
    dataRoomProspectAcceptNdaCreate: (
      params: {
        first_name?: string;
        last_name?: string;
        nda_document_id?: string;
      },
      requestParams: RequestParams = {},
    ) =>
      this.request<DataRoomProspect, any>({
        path: `/investors/data_room/prospect/accept_nda`,
        method: "POST",
        body: params,
        type: ContentType.Json,
        ...requestParams,
      }),

    /**
     * @description Allow a prospect to indicate interest
     *
     * @tags Investor
     * @name DataRoomProspectIndicateInterestCreate
     * @summary Allow a prospect to indicate interest
     * @request POST:/investors/data_room/prospect/indicate_interest
     */
    dataRoomProspectIndicateInterestCreate: (
      params: {
        interested?: string;
        interested_amount?: number;
      },
      requestParams: RequestParams = {},
    ) =>
      this.request<DataRoomProspect, any>({
        path: `/investors/data_room/prospect/indicate_interest`,
        method: "POST",
        body: params,
        type: ContentType.Json,
        ...requestParams,
      }),

    /**
     * @description Fetch the user associated with the current JWT
     *
     * @tags Investor, User
     * @name UserInfo
     * @summary Fetch a user
     * @request GET:/investors/user
     * @secure
     */
    userInfo: (params: RequestParams = {}) =>
      this.request<User, ErrorPayload>({
        path: `/investors/user`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Fetch the organizations associated to the current investor
     *
     * @tags Investor, Organization
     * @name OrganizationList
     * @summary Fetch organizations
     * @request GET:/investors/organizations
     * @secure
     */
    organizationList: (params: RequestParams = {}) =>
      this.request<Organizations, ErrorPayload>({
        path: `/investors/organizations`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Organization details
     *
     * @tags Organization
     * @name OrganizationDetails
     * @summary Organization details
     * @request GET:/investors/organizations/{organization_url_slug}
     * @secure
     */
    organizationDetails: (
      organizationUrlSlug: string,
      params: RequestParams = {},
    ) =>
      this.request<Organization, ErrorPayload>({
        path: `/investors/organizations/${organizationUrlSlug}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Fetch the organization tasks associated to the current investor
     *
     * @tags Investor, Tasks
     * @name TaskList
     * @summary Fetch investment tasks
     * @request GET:/investors/organizations/{organization_url_slug}/available_tasks
     * @secure
     */
    taskList: (organizationUrlSlug: string, params: RequestParams = {}) =>
      this.request<Tasks, ErrorPayload>({
        path: `/investors/organizations/${organizationUrlSlug}/available_tasks`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Investments Overview
     *
     * @tags Investment
     * @name InvestmentsOverview
     * @summary Investments Overview
     * @request GET:/investors/organizations/{org_url_slug}/investments_overview
     * @secure
     */
    investmentsOverview: (orgUrlSlug: string, params: RequestParams = {}) =>
      this.request<InvestmentsOverview, ErrorPayload>({
        path: `/investors/organizations/${orgUrlSlug}/investments_overview`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Document Details
     *
     * @tags Document
     * @name DocumentDetails
     * @summary Document Details
     * @request GET:/investors/organizations/{org_url_slug}/documents/{document_id}
     * @secure
     */
    documentDetails: (
      orgUrlSlug: string,
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<Document, ErrorPayload>({
        path: `/investors/organizations/${orgUrlSlug}/documents/${documentId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description S3 URL to trigger download of the document
     *
     * @tags Document
     * @name DocumentDownloadUrl
     * @summary Document Download URL
     * @request GET:/investors/organizations/{org_url_slug}/documents/{document_id}/download_url
     * @secure
     */
    documentDownloadUrl: (
      orgUrlSlug: string,
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<DocumentDownloadUrl, ErrorPayload>({
        path: `/investors/organizations/${orgUrlSlug}/documents/${documentId}/download_url`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Available filters and options for documents
     *
     * @tags Document, Filters
     * @name DocumentAvailableFilters
     * @summary Available filters and options for documents
     * @request GET:/investors/organizations/{org_url_slug}/documents/available_filters
     * @secure
     */
    documentAvailableFilters: (
      orgUrlSlug: string,
      params: RequestParams = {},
    ) =>
      this.request<ResourceAvailableFilters, ErrorPayload>({
        path: `/investors/organizations/${orgUrlSlug}/documents/available_filters`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description List of Documents for current investor
     *
     * @tags Documents
     * @name Documents
     * @summary List of Documents
     * @request GET:/investors/organizations/{org_url_slug}/documents
     * @secure
     */
    documents: (
      orgUrlSlug: string,
      query?: {
        q?: string;
        "filter_fund_id[]"?: string[];
        "filter_investor_id[]"?: string[];
        "filter_folder_id[]"?: string[];
        /**
         * The selected updated by value
         * @example "past_week"
         */
        filter_updated?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ThinDocument[], ErrorPayload>({
        path: `/investors/organizations/${orgUrlSlug}/documents`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Generates bulk download and emails link to user
     *
     * @tags Documents
     * @name BulkDownload
     * @summary Generate bulk document download
     * @request POST:/investors/organizations/{org_url_slug}/documents/bulk_download
     * @secure
     */
    bulkDownload: (
      orgUrlSlug: string,
      query?: {
        q?: string;
        "filter_fund_id[]"?: string[];
        "filter_investor_id[]"?: string[];
        "filter_folder_id[]"?: string[];
        /**
         * The selected updated by value
         * @example "past_week"
         */
        filter_updated?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorPayload>({
        path: `/investors/organizations/${orgUrlSlug}/documents/bulk_download`,
        method: "POST",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Investment details
     *
     * @tags Investment
     * @name InvestmentDetails
     * @summary Investment details
     * @request GET:/investors/organizations/{organization_url_slug}/investments/{id}
     * @secure
     */
    investmentDetails: (
      organizationUrlSlug: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<Investment, ErrorPayload>({
        path: `/investors/organizations/${organizationUrlSlug}/investments/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Investment members
     *
     * @tags Investment, Members
     * @name Members
     * @summary Investment members
     * @request GET:/investors/organizations/{organization_url_slug}/investments/{investment_id}/members
     * @secure
     */
    members: (
      organizationUrlSlug: string,
      investmentId: string,
      params: RequestParams = {},
    ) =>
      this.request<Member, ErrorPayload>({
        path: `/investors/organizations/${organizationUrlSlug}/investments/${investmentId}/members`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Reassign task to another team member
     *
     * @tags Workflow, Task, Assign
     * @name TaskUpdate
     * @summary Archive current actor and create a new actor for the task
     * @request PATCH:/investors/organizations/{organization_url_slug}/investments/{investment_id}/workflow/{workflow_id}/tasks/{task_id}/assign
     * @secure
     */
    taskUpdate: (
      organizationUrlSlug: string,
      investmentId: string,
      workflowId: string,
      taskId: string,
      bodyParams: ReassignParams,
      params: RequestParams = {},
    ) =>
      this.request<WorkflowTask, ErrorPayload>({
        path: `/investors/organizations/${organizationUrlSlug}/investments/${investmentId}/workflow/${workflowId}/tasks/${taskId}/assign`,
        method: "PATCH",
        body: bodyParams,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Fetch the investment accounts associated to the current user
     *
     * @tags Investor, InvestmentAccount
     * @name InvestmentAccounts
     * @summary Fetch investment accounts
     * @request GET:/investors/investment_accounts
     * @secure
     */
    investmentAccounts: (params: RequestParams = {}) =>
      this.request<ThinInvestmentAccount, ErrorPayload>({
        path: `/investors/investment_accounts`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Fetch the investment account details for the given ID
     *
     * @tags Investor, InvestmentAccount
     * @name InvestmentAccountDetails
     * @summary Investment Account Details
     * @request GET:/investors/investment_accounts/{id}
     * @secure
     */
    investmentAccountDetails: (id: string, params: RequestParams = {}) =>
      this.request<InvestmentAccount, ErrorPayload>({
        path: `/investors/investment_accounts/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Update Investment Account details
     *
     * @tags InvestmentAccount, Entity
     * @name InvestmentAccountUpdate
     * @summary Update Investment Account details
     * @request PUT:/investors/investment_accounts/{id}
     * @secure
     */
    investmentAccountUpdate: (
      id: string,
      investment_account: {
        entity: {
          legal_name?: string;
        };
        type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorPayload>({
        path: `/investors/investment_accounts/${id}`,
        method: "PUT",
        body: investment_account,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description The unobfuscated value associated with a given assignable custom variable key
     *
     * @tags InvestmentAccount
     * @name UnobfuscatedValue
     * @summary Unobfuscated value
     * @request GET:/investors/investment_accounts/{investment_account_id}/unobfuscated_value
     * @secure
     */
    unobfuscatedValue: (
      investmentAccountId: string,
      query: {
        custom_variable_key: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, ErrorPayload>({
        path: `/investors/investment_accounts/${investmentAccountId}/unobfuscated_value`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Fetch capital call investments and their totals
     *
     * @tags CapitalCallInvestments
     * @name CapitalCallInvestments
     * @summary Fetch capital call investments and their totals
     * @request GET:/investors/organizations/{organization_url_slug}/capital_calls
     * @secure
     */
    capitalCallInvestments: (
      organizationUrlSlug: string,
      query?: {
        q?: string;
        "filter_fund_id[]"?: string[];
        "filter_investor_id[]"?: string[];
        "filter_calls[]"?: string[];
        filter_due?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CapitalCallsSummaryResults, ErrorPayload>({
        path: `/investors/organizations/${organizationUrlSlug}/capital_calls`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Available filters and options for capital calls
     *
     * @tags CapitalCall, Filters
     * @name CapitalCallAvailableFilters
     * @summary Available filters and options for capital calls
     * @request GET:/investors/organizations/{org_url_slug}/capital_calls/available_filters
     * @secure
     */
    capitalCallAvailableFilters: (
      orgUrlSlug: string,
      params: RequestParams = {},
    ) =>
      this.request<ResourceAvailableFilters, ErrorPayload>({
        path: `/investors/organizations/${orgUrlSlug}/capital_calls/available_filters`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Invalidates any impersonation requests
     *
     * @tags Investor, Impersonate
     * @name ImpersonateDestroy
     * @summary Destroys impersonation session
     * @request DELETE:/investors/impersonation
     * @secure
     */
    impersonateDestroy: (params: RequestParams = {}) =>
      this.request<void, ErrorPayload>({
        path: `/investors/impersonation`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Investment account members
     *
     * @tags InvestmentAccount, Members
     * @name InvestmentAccountMembers
     * @summary Investment Account Members
     * @request GET:/investors/investment_accounts/{investment_account_id}/members
     * @secure
     */
    investmentAccountMembers: (
      investmentAccountId: string,
      params: RequestParams = {},
    ) =>
      this.request<Members, ErrorPayload>({
        path: `/investors/investment_accounts/${investmentAccountId}/members`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Create investment account member
     *
     * @tags InvestmentAccount, Members
     * @name CreateInvestmentAccountMember
     * @summary Create investment account member
     * @request POST:/investors/investment_accounts/{investment_account_id}/members
     * @secure
     */
    createInvestmentAccountMember: (
      investmentAccountId: string,
      params: {
        email: string;
        first_name?: string;
        last_name?: string;
        /** Communication Types */
        communication_types?: string[];
        /** Entity Member Roles */
        entity_member_roles?: string[];
      },
      requestParams: RequestParams = {},
    ) =>
      this.request<void, ErrorPayload>({
        path: `/investors/investment_accounts/${investmentAccountId}/members`,
        method: "POST",
        body: params,
        secure: true,
        type: ContentType.Json,
        ...requestParams,
      }),

    /**
     * @description Update investment account member
     *
     * @tags InvestmentAccount, Members
     * @name UpdateInvestmentAccountMember
     * @summary Update investment account member
     * @request PATCH:/investors/investment_accounts/{investment_account_id}/members/{member_id}
     * @secure
     */
    updateInvestmentAccountMember: (
      investmentAccountId: string,
      memberId: string,
      params: {
        /** Communication Types */
        communication_types?: string[];
        /** Entity Member Roles */
        entity_member_roles?: string[];
      },
      requestParams: RequestParams = {},
    ) =>
      this.request<void, ErrorPayload | void>({
        path: `/investors/investment_accounts/${investmentAccountId}/members/${memberId}`,
        method: "PATCH",
        body: params,
        secure: true,
        type: ContentType.Json,
        ...requestParams,
      }),

    /**
     * @description Archive investment account member
     *
     * @tags InvestmentAccount, Members
     * @name ArchiveInvestmentAccountMember
     * @summary Archive investment account member
     * @request DELETE:/investors/investment_accounts/{investment_account_id}/members/{member_id}
     * @secure
     */
    archiveInvestmentAccountMember: (
      investmentAccountId: string,
      memberId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorPayload | void>({
        path: `/investors/investment_accounts/${investmentAccountId}/members/${memberId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Send reminder to account member
     *
     * @tags InvestmentAccount, Members
     * @name SendReminder
     * @summary Send reminder to account member
     * @request POST:/investors/investment_accounts/{investment_account_id}/members/{member_id}/send_reminder
     * @secure
     */
    sendReminder: (
      investmentAccountId: string,
      memberId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/investors/investment_accounts/${investmentAccountId}/members/${memberId}/send_reminder`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Make investment account primary contact
     *
     * @tags InvestmentAccount, Members
     * @name MakePrimaryContact
     * @summary Make investment account primary contact
     * @request POST:/investors/investment_accounts/{investment_account_id}/members/{member_id}/make_primary_contact
     * @secure
     */
    makePrimaryContact: (
      investmentAccountId: string,
      memberId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/investors/investment_accounts/${investmentAccountId}/members/${memberId}/make_primary_contact`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
}
